import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Utils } from '@app/_core/helper/Utils';
import { LoaderService } from './loader.service';
import { WebStorageService } from './webstorage.service';
@Injectable({
  providedIn: 'root',
})
export class AuditorService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private webStorageService: WebStorageService,
    private loaderService: LoaderService
  ) {}

  setUserDetails(data: any) {
    let pl: any = {};
    pl = { ...pl, ...data };
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    pl.user = user;
    pl.capResults = true;
    pl.company = company;
    return pl;
  }
  GetInteractions(data: any): any {
    let pl: any = {};
    pl = this.setUserDetails(data);

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetInteractions`, pl).pipe(
      map(res => {
        this.loaderService.display(false);
        if (Array.isArray(res?.Response?.Data?.Data)) {
          res.Response.Data.Data.forEach((item: any) => {
            item.Company = Utils.GetDecodedString(item.Company);
          });
        }
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  GetAudits(payload): any {
    let pl: any = {};
    pl = this.setUserDetails(payload);

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetAudits`, pl).pipe(
      map(res => {
        this.loaderService.display(false);

        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  // HasAuditSurveyExperience() {

  //   // const uc = { includeAllLoginParams: false ,user:user,company:company};
  //   const uc = { company: '', username: '', password: '', sessionID: '', appClientType: '', applicationDesktopID: null };
  //   uc.username = 'Manoj.D.Gupta@cognizant.com';
  //   uc.password = 'Help@54321';
  //   uc.sessionID = '';
  //   uc.appClientType = 'Browser';
  //   uc.company = 'QA1';
  //   // this.loaderService.display(true);
  //   return this.http.post<any>(`${environment.apiUrl}api/user/login`, uc).pipe(
  //     // return this.http.post<any>(`${environment.apiUrl}api/services/Manager/GetQueues`, uc).pipe(
  //     map((res) => {
  //       this.loaderService.display(false);

  //       res = { "Response": { "Data": true, "Status": 1, "Message": null }, "Status": 1, "Message": null }
  //       return res;

  //       //return res;
  //     }),
  //     catchError(this.handleError.bind(this))
  //     //this.handleError

  //   );
  // }

  hasAuditSurveyExperience(): any {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user, company: company };

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/HasAuditSurveyExperience`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        //res = {"Response":{"Data":true,"Status":1,"Message":null},"Status":1,"Message":null}
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  GetAIInteractionDetailsById(data): any {
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetAIInteractionDetails`, data).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  GetLastSurveyComment(data): any {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    
    const ucc = {
      user: user,
      company: company,
      surveyID: data.surveyID,
      fieldGroupID: data.fieldGroupID,
      fieldName: data.fieldName
    };
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetLastSurveyComment`, ucc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  GetInteractionsDetailById(data): any {
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/InteractionDetails`, data).pipe(
      map(res => {
        this.loaderService.display(false);

        /* let res= {
           "Response": {
               "Data": {
                   "ID": 0,
                   "Type": null,
                   "Name": null,
                   "InteractionID": 10885,
                   "InteractionType": "OutboundCall",
                   "Agent": "Shubham Kumar",
                   "Group": "Test Group",
                   "Manager": "Divya Rajendrian",
                   "Queue": "Outbound",
                   "User": "Srinivas Ramdas",
                   "AgentID": 1149,
                   "UserID": 1014,
                   "ThreadID": null,
                   "Thread": null,
                   "Company": null,
                   "CrmUserID": "294082",
                   "Disposition": "Call Disconnected by caller",
                   "DispositionType": null,
                   "Date": "\/Date(1692014933070)\/",
                   "VideoRecording": null,
                   "VideoChatRecording": null,
                   "Recording": null,
                   "Transcript": null,
                   "HandlingTime": 0,
                   "TotalHoldTime": null,
                   "Started": "\/Date(1692014848900)\/",
                   "Queued": null,
                   "Answered": null,
                   "Ended": "\/Date(1692014868242)\/",
                   "Comments": "",
                   "DialerBypassed": false,
                   "BypassExplanation": null,
                   "PhoneNumber": "+919902897172",
                   "FollowUpDate": null,
                   "FollowUpType": "None",
                   "RequestType": null,
                   "WeekIndex": null,
                   "Scorecards": 0,
                   "Calibrations": 0,
                   "Evaluations": 0,
                   "ScorecardOwner": false,
                   "CalibrationOwner": false,
                   "EvaluationOwner": false,
                   "UserData": "{\"CrmUserID\":\"294082\",\"FirstName\":\"Srinivas\",\"LastName\":\"Ramdas\",\"OT\":\"\",\"Email\":\"srinivas@gmail.com\",\"Designation\":\"Trainees\",\"GradeBand\":\"T3\",\"Address1\":\"\",\"Address2\":\"\",\"Country\":\"UNITED STATES\",\"State\":\"GEORGIA\",\"City\":\"QQ\",\"Zip\":\"\",\"Reporting Manager Employee ID\":\"\",\"Reporting Manager First Name\":\"\",\"Reporting Manager Last Name\":\"\",\"Reporting Manager Email Address\":\"\",\"Reporting Manager Contact Number\":\"\",\"Organization Name\":\"\",\"Department or Divison\":\"Sales\",\"UserID\":\"1014\",\"PhoneNumbers\":\"Fax: 12211212122121\"}"
               },
               "Status": 1,
               "Message": null
           },
           "Status": 1,
           "Message": null
       }*/
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  GetSurveysGroupedByDefinition(id): any {
    const interactionID = id;
    const experienceTypeID = null;
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = {
      user: user,
      company: company,
      interactionID: interactionID,
      experienceTypeID: experienceTypeID,
    };
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetSurveysGroupedByDefinition`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        /*let res = {
          "Response": {
            "Data": [
              {
                "SurveyDefinitionID": 1,
                "Name": "E3S_Service_Desk",
                "ExperienceTypeID": 47,
                "GroupID": null,
                "Group": null,
                "Disabled": false,
                "NegativeScoring": true,
                "Sections": [],
                "Surveys": [
                  {
                    "SurveyID": 1229,
                    "AccessKeyID": null,
                    "InteractionID": 10885,
                    "CaseID": null,
                    "SurveyDefinitionID": 1,
                    "Type": {
                      "ID": 4,
                      "Name": "Evaluation",
                      "Description": "The survey is feedback/evaluation from manager.",
                      "ShortName": "",
                      "AbbreviatedName": ""
                    },
                    "Status": {
                      "ID": 2,
                      "Name": "InProgress",
                      "ShortName": "",
                      "AbbreviatedName": "",
                      "Description": "The survey is in progress by Auditor."
                    },
                    "Score": 84.8,
                    "Created": "\/Date(1694878003680)\/",
                    "LastUpdated": "\/Date(1694878004493)\/",
                    "User": {
                      "UserID": 3331,
                      "Email": "praveenraj.manoharan@cognizant.com",
                      "FirstName": "Praveenraj",
                      "LastName": "Manoharan",
                      "Grants": [
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 1,
                          "Name": "TM"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 2,
                          "Name": "Admin"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 5,
                          "Name": "ManageUsers"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 6,
                          "Name": "Twilio"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 9,
                          "Name": "Reporting"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 15,
                          "Name": "AuditAgents"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 16,
                          "Name": "ManageAgents"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 22,
                          "Name": "ManageIVR"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 23,
                          "Name": "ManageCampaigns"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 24,
                          "Name": "ManageAssignments"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 25,
                          "Name": "LiveView"
                        }
                      ],
                      "PhoneNumbers": [],
                      "GlobalRole": {
                        "RoleID": 7,
                        "AuthLevel": 5,
                        "Name": "ClientAdmin",
                        "Grants": [
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 2,
                            "Name": "Admin"
                          },
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 5,
                            "Name": "ManageUsers"
                          },
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 9,
                            "Name": "Reporting"
                          },
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 10,
                            "Name": "Preview"
                          },
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 11,
                            "Name": "ApproveContent"
                          }
                        ]
                      },
                      "AvatarLocation": null
                    },
                    "Agent": {
                      "UserID": 1149,
                      "Email": "shubham.kumar5@cognizant.com",
                      "FirstName": "Shubham",
                      "LastName": "Kumar",
                      "Grants": [
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 1,
                          "Name": "TM"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 4,
                          "Name": "API"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 5,
                          "Name": "ManageUsers"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 6,
                          "Name": "Twilio"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 9,
                          "Name": "Reporting"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 10,
                          "Name": "Preview"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 11,
                          "Name": "ApproveContent"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 13,
                          "Name": "SoftphoneOnly"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 15,
                          "Name": "AuditAgents"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 16,
                          "Name": "ManageAgents"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 20,
                          "Name": "Wallboards"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 22,
                          "Name": "ManageIVR"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 24,
                          "Name": "ManageAssignments"
                        },
                        {
                          "GlobalGrantID": 0,
                          "ClientGrantID": 25,
                          "Name": "LiveView"
                        }
                      ],
                      "PhoneNumbers": [
                        {
                          "PhoneNumberID": 13,
                          "Number": "(000) 000-0000",
                          "StrippedNumber": "0000000000",
                          "Type": "Business"
                        }
                      ],
                      "GlobalRole": {
                        "RoleID": 7,
                        "AuthLevel": 5,
                        "Name": "ClientAdmin",
                        "Grants": [
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 2,
                            "Name": "Admin"
                          },
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 5,
                            "Name": "ManageUsers"
                          },
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 9,
                            "Name": "Reporting"
                          },
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 10,
                            "Name": "Preview"
                          },
                          {
                            "GlobalGrantID": 0,
                            "ClientGrantID": 11,
                            "Name": "ApproveContent"
                          }
                        ]
                      },
                      "AvatarLocation": "/PrivateFiles/HR1/files/216/download.jfif"
                    },
                    "IsOwner": true,
                    "IsAgent": false,
                    "Sections": []
                  }
                ],
                "Types": [
                  {
                    "ID": 4,
                    "Name": "Evaluation",
                    "Description": "The survey is feedback/evaluation from manager.",
                    "ShortName": "",
                    "AbbreviatedName": ""
                  }
                ]
              },
              {
                "SurveyDefinitionID": 2,
                "Name": "E3S_Service_Desk_02012023",
                "ExperienceTypeID": 47,
                "GroupID": null,
                "NegativeScoring": true,
                "Surveys": [],
                "Group": null,
                "Disabled": false,
                "Sections": [],
                "Types": [
                  {
                    "ID": 4,
                    "Name": "Evaluation",
                    "Description": "The survey is feedback/evaluation from manager.",
                    "ShortName": "",
                    "AbbreviatedName": ""
                  }
                ]
              }
            ],
            "Status": 1,
            "Message": null
          },
          "Status": 1,
          "Message": null
        }*/
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  GetSurveyDefinitions(id): any {
    const interactionID = id;
    const experienceTypeID = null;
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = {
      user: user,
      company: company,
      interactionID: interactionID,
      experienceTypeID: experienceTypeID,
      getAllData: false,
      getRelatedSurveys: true,
      getRelatedSurveySections: false,
      filterTypesByAuditRole: true,
    };
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetSurveyDefinitions`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  GetSurveyDefinition(id): any {
    const surveyDefinitionID = id;
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc:any = {};
    uc.user = user;
    uc.company = company;
    uc.surveyDefinitionID = surveyDefinitionID;
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetSurveyDefinition`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  EditSurveyComments(data): any {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc: any = {};
    uc.user = user;
    uc.company = company;
    uc.surveyID = data.surveyID;
    uc.commentID = data.commentID;
    uc.fieldGroupID = data.fieldGroupID;
    uc.fieldName = data.fieldName;
    uc.content = data.content;

    const ucc = {
      user: user,
      company: company,
      surveyID: data.surveyID,
      commentID: data.commentID ? data.commentID : null,
      fieldGroupID: data.fieldGroupID,
      fieldName: data.fieldName,
      content: data.content,
    };
    //console.log(uc, 'payload');

    // const uc = { 'user': user, 'company': company, 'surveyID': surveyDefinitionID };
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/EditSurveyComment`, ucc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  GetSurveyPermissions(id: number): any {
    const surveyID = id;
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user, company: company, surveyID: surveyID };
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetSurveyPermissions`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  GetSurvey(id: number, payload: any): any {
    const surveyID = id;
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = payload == null 
      ? { user: user, company: company, surveyID: surveyID } 
      : { user: user, company: company, ...payload };
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetSurvey`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  saveSubmitSurvey(data) {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');

    //console.log(data);

    const uc: any = {};
    uc.user = user;
    uc.company = company;
    uc.surveyID = data.surveyID;
    uc.surveyActionID = data.surveyActionID;
    uc.surveyTypeID = data.surveyTypeID;
    uc.surveyDefinitionID = data.surveyDefinitionID;
    uc.interactionID = data.interactionID;
    uc.survey = data.survey;
    uc.overwrite = data.overwrite;
    uc.scorecheck = false;

    const ucc = {
      user: user,
      company: company,
      surveyID: data.surveyID,
      surveyActionID: data.surveyActionID,
      surveyTypeID: data.surveyTypeID,
      surveyDefinitionID: data.surveyDefinitionID,
      interactionID: data.interactionID,
      survey: data.survey,
      overwrite: data.overwrite,
      scorecheck: false,
      isCompliance: data.isCompliance
    };
    //console.log(uc, 'payload');

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/SubmitSurvey`, ucc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  getExportExcel(surveyID, complianceData = null) {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    let exportUrl = environment.loginUrl;
    if (exportUrl.includes('/Angular/'))
    {
      exportUrl = exportUrl.replace('/Angular/', '/login');
    }
    const uc = {
      user: user,
      company: company,
      surveyID: surveyID,
      url: exportUrl,
      complianceData: complianceData
      //url: 'https://tm.stage.cts-connect.com/#!/BCH/Console/Interactions/Details/1450531',
    };
    // this.loaderService.display(true);
    return this.http.post(`${environment.apiUrl}api/service/auditor/GetExcel`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getUserStats() {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user, company: company };
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/service/auditor/GetUserStats`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
}
